import { useAuth } from '@/Context/AuthContext'
import React from 'react'
import { Button } from '@/Components/ui/button'

const ActionButton = ({ event, updateEvent, handleAction }) => {
    const { userInfo, actionButton } = useAuth()

    const { chart_status, question1, question2, question3, tioc_query, tioc_query2, tioc_query3 } = event.work_allocation || {}

    const hasQuestions = question1 !== null || question2 !== null || question3 !== null

    const hasTIOCQueries = tioc_query !== null || tioc_query2 !== null || tioc_query3 !== null

    const allFieldsNull =
        question1 === null && question2 === null && question3 === null && tioc_query === null && tioc_query2 === null && tioc_query3 === null

    const matchedButtons = actionButton.filter((wf) => userInfo.roles.includes(wf.allowed) && wf.state === chart_status)

    let hasRenderedQuery = false
    return (
        <>
            {matchedButtons.map((wf, index) => {
                if (hasQuestions && wf.action === 'Query Answered') {
                    return (
                        <Button key={wf.name} className="bg-primary-purpal hover:bg-primary-purpal px-4" onClick={() => handleAction(wf.action)}>
                            {wf.action}
                        </Button>
                    )
                } else if (hasQuestions && !hasRenderedQuery) {
                    hasRenderedQuery = true
                    console.log('hasquestions', hasQuestions, wf.action)
                    return (
                        <Button key={index} className="bg-primary-purpal hover:bg-primary-purpal px-4" onClick={() => handleAction('Query')}>
                            Query
                        </Button>
                    )
                }

                if (hasTIOCQueries && wf.action === 'TIOC Query Answered') {
                    return (
                        <Button key={wf.name} className="bg-primary-purpal hover:bg-primary-purpal px-4" onClick={() => handleAction(wf.action)}>
                            {wf.action}
                        </Button>
                    )
                } else if (hasTIOCQueries && !hasRenderedQuery) {
                    hasRenderedQuery = true
                    console.log('hasquestions', hasQuestions, wf.action)
                    return (
                        <Button key={index} className="bg-primary-purpal hover:bg-primary-purpal px-4" onClick={() => handleAction('TIOC Query')}>
                            TIOC Query
                        </Button>
                    )
                }

                if (allFieldsNull && ['Completed'].includes(wf.action)) {
                    return (
                        <Button key={wf.name} className="bg-primary-purpal hover:bg-primary-purpal px-4" onClick={() => handleAction(wf.action)}>
                            {wf.action}
                        </Button>
                    )
                }

                return null
            })}
        </>
    )
}

export default ActionButton
